<script>
import axios from "axios";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ExcelJS from 'exceljs';

export default {
  name: "global-reporting",
  components: {
        Datepicker
      },
  mixins: [],
  data() {

    const end = new Date();
    end.setHours(23, 59, 59, 999);
    const start = new Date(end);
    start.setDate(end.getDate() - 91);
    start.setHours(0, 0, 0, 0);

    return {
      userPickedDateRange: false,
      customDataLoaded: false,
      dateRangeDefault: [start, end],
      dateRangeCustom: null, // Will hold [start, end] as Date objects
      minSelectableDate: new Date(2023, 0, 1), // January is month 0
      maxSelectableDate: new Date(),
      rawDailyDefault: [],
      dailyStatsDefault: [],
      weeklyStatsDefault: [],
      rawDailyCustom: [],
      dailyStatsCustom: [],
      weeklyStatsCustom: [],
      hasFetchedMoreDefault: false,
      extraDailyData: [],
      extraWeeklyData: [],
      rawMonthly: [],
      monthlyStats: [],
      quarterlyStats: [],
      halfyearlyStats: [],
      yearlyStats: [],
      ratePLN: 5.81,
      rateEUR: 24.81,
      filters: {
        orderSelect: "all",
        currencySelect: "czk",
        periodSelect: "year",
        deltaSelect: "chr",
        eshopSelect: [
          "onlinejazyky_old",
          "onlinejazyky_info",
          "onlinejazyky_eshop",
          "easylingo_com_cs",
          "konverzacniklub_cz",
          "milujujazyky_cz",
          "onlajnovka",
          "studovna_oj",
        ],
        contentSelect: "sales"
      },
      eshop_list: {},
      eshopOptions: ["easylingo_com_es",
        "easylingo_com_en",
        "easylingo_com_cs",
        "easylingo_com_pl",
        "easylingo_com_sk",
        "onlinejazyky_old",
        "onlinejazyky_info",
        "onlinejazyky_eshop",
        "konverzacniklub_cz",
        "jazykovedarky_cz",
        "milujujazyky_cz",
        "umenijazyku_cz",
        "onlajnovka",
        "studovna_oj",
        "studovna_el",
        "fapi_sk",
      ],
      eshopMap: {
        "easylingo_com_es": [1],
        "easylingo_com_en": [2],
        "easylingo_com_cs": [3, 4, 10],
        "easylingo_com_pl": [11],
        "easylingo_com_sk": [9],
        "onlinejazyky_old": [0],
        "onlinejazyky_info": [5],
        "onlinejazyky_eshop": [6],
        "konverzacniklub_cz": [7, 16],
        "konverzacniklub_sk": [14],
        "jazykovedarky_cz": [12],
        "milujujazyky_cz": [15],
        "umenijazyku_cz": [8],
        "fapi_sk": [17],
        "studovna_oj": [18],
        "onlajnovka": [19],
        "studovna_el": [20],
      },
      aliasMap: {
        "easylingo_com_es": "EL ES",
        "easylingo_com_en": "EL EN",
        "easylingo_com_cs": "EL CZ",
        "easylingo_com_pl": "EL PL",
        "easylingo_com_sk": "EL SK",
        "onlinejazyky_old": "OJ",
        "onlinejazyky_eshop": "OJ new",
        "onlinejazyky_info": "OJ info",
        "konverzacniklub_cz": "KK CZ",
        "konverzacniklub_sk": "KK SK",
        "jazykovedarky_cz": "JAZ D",
        "milujujazyky_cz": "MIL J",
        "umenijazyku_cz": "UME J",
        "fapi_sk": "FAPI",
        "studovna_oj": "STU OJ",
        "onlajnovka": "ONLA",
        "studovna_el": "STU EL",
      },
      periodLabels: {
        "year": "roční",
        "half": "pololetní",
        "quarter": "kvartální",
        "month": "měsíční",
        "week": "týdenní",
        "day": "denní"
      },
      periodMap: {
        "day": false,
        "week": false,
        "month": true,
        "quarter": true,
        "half": true,
        "year": true
      },
      contentOptions: ["sales", "count"],
    };
  },

  // COMPUTED SECTION******************************************************************************************

  computed: {
    isAllChecked: {
      get() {
        return this.filters.eshopSelect.length === this.eshopOptions.length;
      },
      set(value) {
        if (value) {
          // If "All" is checked, select all checkboxes
          this.filters.eshopSelect = [...this.eshopOptions];
        } else {
          // If "All" is unchecked, clear all checkboxes (quick cleanup)
          this.filters.eshopSelect = [];
        }
      }
    },

    isButtonDisabled() {
      return false; // Allow clicking the button even if conditions are not met
    },

    isEshopSelected() {
      return this.filters.eshopSelect.length > 0;
    },

    isPeriodDataAvailable() {
      if (['month', 'quarter', 'half', 'year'].includes(this.filters.periodSelect)) {
        return this.rawMonthly && this.rawMonthly.length > 0;
      } else if (this.filters.periodSelect === 'week') {
        return this.customDataLoaded && this.weeklyStatsCustom.length > 0 || this.weeklyStatsDefault.length > 0;
      } else if (this.filters.periodSelect === 'day') {
        return this.customDataLoaded && this.dailyStatsCustom.length > 0 || this.dailyStatsDefault.length > 0;
      }
      return false;
    },

    tableTitle() {
      const var1 = this.filters.contentSelect === "sales" ? "Tržby u" : "Počet";
      const var2 = this.filters.orderSelect === "all" ? "všech" : "zaplacených";
      const var3 = this.periodLabels[this.filters.periodSelect] || "";
      const var4 = this.filters.currencySelect.toUpperCase();

      return `${var1} ${var2} objednávek - ${var3} přehled v ${var4}`;
    },

    sortedYearlyStats() {
      return [...this.yearlyStats].sort((a, b) => b.year - a.year);
    },

    sortedHalfYearlyStats() {
      return [...this.halfyearlyStats].sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        return b.half - a.half;
      });
    },

    sortedQuarterlyStats() {
      return [...this.quarterlyStats].sort((a, b) => {
        // Parse like "2Q 2024"
        const [qa, ya] = String(a.row_label).split('Q').map(x => x.trim());
        const [qb, yb] = String(b.row_label).split('Q').map(x => x.trim());
        if (yb !== ya) return Number(yb) - Number(ya);
        return Number(qb) - Number(qa);
      });
    },

    sortedMonthlyStats() {
      return [...this.monthlyStats].sort((a, b) => {
        // Newest month/year on top
        if (a.year !== b.year) return b.year - a.year;
        return b.month - a.month;
      });
    },

    sortedWeeklyStats() {
      const arr = this.customDataLoaded && this.weeklyStatsCustom.length ? this.weeklyStatsCustom : this.weeklyStatsDefault;
      // Keep the date range filter if desired:
      if (this.customDataLoaded && this.dateRangeCustom) {
        const [start, end] = this.dateRangeCustom;
        const { week: startWeek, year: startYear } = this.getISOWeekAndYear(this.formatLocalDate(start));
        const { week: endWeek, year: endYear } = this.getISOWeekAndYear(this.formatLocalDate(end));
        return arr.filter(item => {
          const [week, year] = item.row_label.split(' ').map(Number);
          const afterStart = year > startYear || (year === startYear && week >= startWeek);
          const beforeEnd = year < endYear || (year === endYear && week <= endWeek);
          return afterStart && beforeEnd;
        }).sort((a, b) => {
          const [wa, ya] = a.row_label.split(' ').map(Number);
          const [wb, yb] = b.row_label.split(' ').map(Number);
          return yb - ya || wb - wa;
        });
      }
      return arr.sort((a, b) => {
        const [wa, ya] = a.row_label.split(' ').map(Number);
        const [wb, yb] = b.row_label.split(' ').map(Number);
        return yb - ya || wb - wa;
      });
    },

    sortedDailyStats() {
      const arr = this.customDataLoaded && this.dailyStatsCustom.length ? this.dailyStatsCustom : this.dailyStatsDefault;
      let filtered = arr;

      if (this.customDataLoaded && this.dateRangeCustom) {
        const [start, end] = this.dateRangeCustom;
        filtered = arr.filter(item => {
          const [d, m, y] = item.row_label.split('/').map(Number);
          const yyyy = y < 50 ? 2000 + y : 1900 + y;
          const dateObj = new Date(yyyy, m - 1, d);
          return dateObj >= start && dateObj <= end;
        });
      }

      return [...filtered].sort((a, b) => {
        const parseDMY = s => {
          const [d, m, y] = s.split('/').map(Number);
          const yyyy = y < 50 ? 2000 + y : 1900 + y;
          return new Date(yyyy, m - 1, d);
        };
        return parseDMY(b.row_label) - parseDMY(a.row_label);
      });
    },

    globalMatrix() {
      let stats, getRowLabel, groupKeys;
      switch (this.filters.periodSelect) {
        case 'year':
          stats = this.sortedYearlyStats;
          getRowLabel = r => `${r.year}`;
          groupKeys = r => [r.year];
          break;
        case 'half':
          stats = this.sortedHalfYearlyStats;
          getRowLabel = r => `${r.half} ${r.year}`;
          groupKeys = r => [r.year, r.half];
          break;
        case 'quarter':
          stats = this.sortedQuarterlyStats;
          getRowLabel = r => `${r.quarter}Q ${String(r.year).slice(-2)}`;
          groupKeys = r => [r.year, r.quarter];
          break;
        case 'month':
          stats = this.sortedMonthlyStats;
          getRowLabel = r => r.row_label;
          groupKeys = r => [r.year, r.month];
          break;
        case 'week':
          stats = this.sortedWeeklyStats;
          getRowLabel = r => r.row_label;
          groupKeys = r => [r.row_label];
          break;
        case 'day':
          stats = this.sortedDailyStats;
          getRowLabel = r => r.row_label;
          groupKeys = r => [r.row_label];
          break;
        default:
          return [];
      }

      const now = new Date();
      const rows = [];
      const seen = new Set();
      const eshops = this.filters.eshopSelect;

      // Apply 'orderSelect' filter
      const paidFilter = this.filters.orderSelect === "all" ? "all_statuses" : "completed";
      stats = stats.filter(s => s.paid === paidFilter);

      for (const r of stats) {
        const keyArr = groupKeys(r);
        const groupKey = keyArr.join('|');
        if (seen.has(groupKey)) continue;
        seen.add(groupKey);

        // Skip future dates
        let isFuture = false;
        switch (this.filters.periodSelect) {
          case 'year':
            isFuture = r.year > now.getFullYear();
            break;
          case 'half':
            isFuture = r.year > now.getFullYear() || (r.year === now.getFullYear() && r.half > (now.getMonth() < 6 ? 1 : 2));
            break;
          case 'quarter':
            isFuture = r.year > now.getFullYear() || (r.year === now.getFullYear() && r.quarter > (Math.floor(now.getMonth() / 3) + 1));
            break;
          case 'month':
            isFuture = r.year > now.getFullYear() || (r.year === now.getFullYear() && r.month > now.getMonth() + 1);
            break;
          case 'week': {
            const [weekNum, yearNum] = r.row_label.split(' ').map(Number);
            const { week: currentWeek, year: currentYear } = this.getISOWeekAndYear(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`);
            isFuture = yearNum > currentYear || (yearNum === currentYear && weekNum > currentWeek);
            break;
          }
          case 'day': {
            const [d, m, y] = r.row_label.split('/').map(Number);
            const dateObj = new Date(y < 50 ? 2000 + y : 1900 + y, m - 1, d);
            isFuture = dateObj > now;
            break;
          }
        }
        if (isFuture) continue;

        let row = { row_label: getRowLabel(r) };
        let total = 0;
        for (const eshop of eshops) {
          let value = 0;
          const stat = stats.find(s => {
            let keysMatch = true;
            groupKeys(s).forEach((val, idx) => {
              if (val !== keyArr[idx]) keysMatch = false;
            });
            const eshopMatch = s.eshop_id === (Array.isArray(this.eshopMap[eshop]) ? this.eshopMap[eshop][0] : this.eshopMap[eshop]);
            return keysMatch && eshopMatch;
          });

          if (stat) {
            if (this.filters.contentSelect === "sales") {
              // "Celkem" logic for totals in CZK
              if (this.filters.currencySelect === "celkem") {
                const czk = Number(stat.sum_czk) || 0;
                const eur = Number(stat.sum_eur) || 0;
                const pln = Number(stat.sum_pln) || 0;
                value = czk + eur * this.rateEUR + pln * this.ratePLN;
              } else if (this.filters.currencySelect === "czk") {
                value = Number(stat.sum_czk) || 0;
              } else if (this.filters.currencySelect === "eur") {
                value = Number(stat.sum_eur) || 0;
              } else if (this.filters.currencySelect === "pln") {
                value = Number(stat.sum_pln) || 0;
              } else {
                value = 0;
              }
            } else {
              // contentSelect is "count"
              value = Number(stat.orders_count) || 0;
            }
          }
// ----- End Value Calculation Block -----
          row[eshop] = value;
          total += Number(value) || 0;

          // if (stat) {
          //   if (this.filters.contentSelect === "sales") {
          //     // *** NEW "celkem" logic ***
          //
          //     if (this.filters.currencySelect === "celkem") {
          //       // Always show in CZK:
          //       const czk = Number(stat.sum_czk) || 0;
          //       const eur = Number(stat.sum_eur) || 0;
          //       const pln = Number(stat.sum_pln) || 0;
          //       value = czk + eur * this.rateEUR + pln * this.ratePLN;
          //     } else if (this.filters.currencySelect === "czk") {
          //       value = Number(stat.sum_czk) || 0;
          //     } else if (this.filters.currencySelect === "eur") {
          //       value = Number(stat.sum_eur) || 0;
          //     } else if (this.filters.currencySelect === "pln") {
          //       value = Number(stat.sum_pln) || 0;
          //     } else {
          //       value = 0;
          //     }
          //   } else {
          //     // contentSelect is "count"
          //     value = Number(stat.orders_count) || 0;
          //   }
          // }

        }
        row.total = total;
        rows.push(row);
      }
      return rows;
    },

    globalMatrixTotals() {
      const totals = {
        total: 0
      };
      this.filters.eshopSelect.forEach(eshop => {
        totals[eshop] = 0;
      });
      this.globalMatrix.forEach(row => {
        this.filters.eshopSelect.forEach(eshop => {
          totals[eshop] += Number(row[eshop]) || 0;
        });
        totals.total += Number(row.total) || 0;
      });
      return totals;
    },

    globalMaxChars() {
      // Include headers in width calc!
      let maxChars = 0;
      // Check data rows
      this.globalMatrix.forEach(row => {
        this.filters.eshopSelect.concat('total').forEach(eshop => {
          const val = row[eshop];
          const s = this.formatNumber(val);
          if (s.length > maxChars) maxChars = s.length;
        });
      });
      // Also check header (aliasMap), for "Celkem" too
      this.filters.eshopSelect.concat('total').forEach(eshop => {
        const head = eshop === 'total' ? 'Celkem' : this.aliasMap[eshop] || eshop;
        if (head.length > maxChars) maxChars = head.length;
      });
      return maxChars;
    },

    globalColumnStyle() {
      // 1ch = width of 0 in monospace, but also looks ok in sans-serif
      return {
        width: (this.globalMaxChars + 2) + 'ch',
        minWidth: '60px',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      };
    },

    currentPeriodKey() {
      const now = new Date();
      const year = now.getFullYear();
      switch (this.filters.periodSelect) {
        case 'year':
          return `${year}`;
        case 'half':
          const half = now.getMonth() < 6 ? 1 : 2;
          return `${half} ${year}`;
        case 'quarter':
          const quarter = Math.floor(now.getMonth() / 3) + 1;
          return `${quarter}Q ${year}`;
          // const quarter = Math.floor(now.getMonth() / 3) + 1;
          // return `${quarter}Q ${String(year).slice(-2)}`;
        case 'month':
          const czechMonth = now.toLocaleString("cs-CZ", { month: "short" }).toUpperCase();
          return `${czechMonth} ${year}`;
        case 'week': {
          const { week, year: weekYear } = this.getISOWeekAndYear(`${year}-${now.getMonth() + 1}-${now.getDate()}`);
          return `${week} ${weekYear}`;
        }
        case 'day':
          const dd = String(now.getDate()).padStart(2, "0");
          const mm = String(now.getMonth() + 1).padStart(2, "0");
          const yy = String(year).slice(-2);
          return `${dd}/${mm}/${yy}`;
        default:
          return null;
      }
    },

    yearOnYearMaxChars() {
      let maxChars = 0;
      const data = this.sortedYearOnYear();

      // Include headers
      this.filters.eshopSelect.concat('total').forEach(eshop => {
        const header = eshop === 'total' ? 'Celkem' : this.aliasMap[eshop] || eshop;
        if (header.length > maxChars) maxChars = header.length;
      });

      // Check data rows
      data.forEach(row => {
        this.filters.eshopSelect.concat('total').forEach(eshop => {
          const val = eshop === 'total' ? row.total : row[eshop];
          const s = this.formatNumber(val);
          if (s.length > maxChars) maxChars = s.length;
        });
      });

      return maxChars;
    },

    yearOnYearColumnStyle() {
      return {
        width: (this.yearOnYearMaxChars + 2) + 'ch',
        minWidth: '60px',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      };
    },

    groupIndexMap() {
      return this.getGroupIndexMap(this.sortedYearOnYear());
    }


  },

  // WATCH SECTION ***********************************************************

  watch: {

    dateRange: {
      handler(newRange) {
        if (!Array.isArray(newRange) || newRange.length !== 2) {
          this.dateRangeCustom = null;
          return;
        }

        let [start, end] = newRange;

        // Earliest allowed
        const minDate = new Date(2023, 0, 1); // Jan 1, 2023
        // Latest allowed (today)
        const maxDate = new Date();
        maxDate.setHours(23,59,59,999);

        // Clamp start and end within allowed bounds
        if (start < minDate) start = new Date(minDate);
        if (end > maxDate) end = new Date(maxDate);

        // Ensure start <= end
        if (start > end) [start, end] = [end, start];

        // Max spread is 92 days (inclusive)
        const maxSpread = 91; // Because start + 91 = 92 days inclusive
        const msInDay = 24 * 60 * 60 * 1000;
        const spread = Math.round((end - start) / msInDay);

        if (spread > maxSpread) {
          // Too wide: shift start forward
          start = new Date(end);
          start.setDate(end.getDate() - maxSpread);
          // Still can't go below minDate
          if (start < minDate) start = new Date(minDate);
        }

        // Assign, always as [start, end] in order
        this.dateRangeCustom = [start, end];
      },
      immediate: true,
      deep: true
    },

    dateRangeCustom: {
      handler(newRange) {
        if (!Array.isArray(newRange) || newRange.length !== 2) return;

        // Clone to avoid mutating the picker value directly
        let [start, end] = [new Date(newRange[0]), new Date(newRange[1])];
        start.setHours(0, 0, 0, 0);         // Set start to 00:00:00.000
        end.setHours(23, 59, 59, 999);      // Set end to 23:59:59.999

        // Only update if times actually changed (to avoid infinite loop)
        if (
            start.getTime() !== newRange[0].getTime() ||
            end.getTime() !== newRange[1].getTime()
        ) {
          // Update with sanitized times
          this.dateRangeCustom = [start, end];
        }
      },
      immediate: true,
      deep: true
    },

    'filters.periodSelect'(newPeriod) {
      const allowedDeltaPeriods = ['month', 'quarter', 'half'];
      if (!allowedDeltaPeriods.includes(newPeriod) && this.filters.deltaSelect === 'yea') {
        this.filters.deltaSelect = 'chr';  // Reset to chronological
      }
    },

    'filters.currencySelect'(newVal) {
      if (newVal === 'pln') {
        // If PLN is selected, only allow easylingo_com_pl
        this.filters.eshopSelect = ['easylingo_com_pl'];
      } else if (newVal === 'czk') {
        // If CZK is selected, only allow easylingo_com_cs
        this.filters.eshopSelect = ["onlinejazyky_old",
          "onlinejazyky_info",
          "onlinejazyky_eshop",
          "easylingo_com_cs",
          "konverzacniklub_cz",
          "milujujazyky_cz",
          "onlajnovka",
          "studovna_oj"];
      } else if (newVal === 'eur') {
        // If EUR is selected, only allow easylingo_com_en
        this.filters.eshopSelect = ['easylingo_com_en', 'easylingo_com_es', 'easylingo_com_sk',"onlinejazyky_old","milujujazyky_cz", 'fapi_sk'];
      } else if (newVal === 'celkem') {
        // If "all" is selected, select ALL e-shops
        this.filters.eshopSelect = [...this.eshopOptions];
      }
    }

  },

  // METHODS SECTION******************************************************

  methods: {

    formatLocalDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    fetchOnLoad() {
      const payloadMonthly = { period_type: "month" };

      const [start, end] = this.dateRangeDefault;
      const payloadDaily = {
        period_type: "day",
        from_date: this.formatLocalDate(start),
        to_date: this.formatLocalDate(end)
      };

      this.monthlyStats = [];
      this.dailyStatsDefault = [];

      axios.post("/reporting/global_reporting_filter", payloadMonthly)
          .then(response => {
            this.rawMonthly = response.data.marketings_select || [];
            this.monthlyStats = this.processMonthlyStats(this.rawMonthly);
            this.processYearlyStats();
            this.processHalfYearlyStats();
            this.processQuarterlyStats();
          })
          .catch(error => {
            this.rawMonthly = [];
            this.monthlyStats = [];
            this.yearlyStats = [];
            this.halfyearlyStats = [];
            this.quarterlyStats = [];
          });

      axios.post("/reporting/global_reporting_filter", payloadDaily)
          .then(response => {
            this.rawDailyDefault = response.data.marketings_select || [];
            this.dailyStatsDefault = this.processDailyStats(this.rawDailyDefault);
            this.weeklyStatsDefault = this.processWeeklyStats(this.dailyStatsDefault);
          })
          .catch(error => {
            this.rawDailyDefault = [];
            this.dailyStatsDefault = [];
            this.weeklyStatsDefault = []
          });
    },

    validateAndSubmit() {
      this.userPickedDateRange = true;
      this.fetchDailyCustom();
    },

    fetchDailyCustom() {
      // Guard: only fetch if we have a valid custom date range
      if (!this.dateRangeCustom || this.dateRangeCustom.length !== 2 || !this.dateRangeCustom[0] || !this.dateRangeCustom[1]) {
        this.rawDailyCustom = [];
        this.customDataLoaded = false;
        return;
      }
      const [start, end] = this.dateRangeCustom;
      const payload = {
        period_type: "day",
        from_date: this.formatLocalDate(start),
        to_date: this.formatLocalDate(end),
      };

      this.rawDailyCustom = [];
      this.customDataLoaded = false;

      axios
          .post("/reporting/global_reporting_filter", payload)
          .then((response) => {
            console.log("Custom daily data:", response.data.marketings_select);
            this.rawDailyCustom = response.data.marketings_select || [];
            this.dailyStatsCustom = this.processDailyStats(this.rawDailyCustom);
            this.weeklyStatsCustom = this.processWeeklyStats(this.dailyStatsCustom);
            this.customDataLoaded = true;
          })
          .catch((error) => {
            this.rawDailyCustom = [];
            this.dailyStatsCustom = [];
            this.weeklyStatsCustom = [];
            this.customDataLoaded = false;
          });
    },

    getAliasById(id) {
      for (const [name, ids] of Object.entries(this.eshopMap)) {
        if (Array.isArray(ids) ? ids.includes(id) : ids === id) {
          return this.aliasMap[name] || name;
        }
      }
      return id;
    },

    processYearlyStats() {
      // Step 1: Filter for monthly subtotal rows only
      const monthly = this.rawMonthly.filter(
          item => item.month !== null && item.day === null
      );

      // Step 2: Group by eshop, year, paid
      // We'll use a helper map for summing, then turn it into an array
      const groupMap = {};

      monthly.forEach(item => {
        // Get year from month (e.g. "2024-12" => 2024)
        const year = parseInt(item.month.split('-')[0], 10);
        const key = `${item.eshop_id}_${year}_${item.paid}`;

        if (!groupMap[key]) {
          groupMap[key] = {
            eshop_id: item.eshop_id,
            eshop_name: this.getAliasById(item.eshop_id),
            year,
            row_label: year,
            paid: item.paid,
            sum_czk: 0,
            sum_eur: 0,
            sum_pln: 0,
            orders_count: 0
          };
        }

        // Parse floats for sum_czk and sum_eur
        groupMap[key].sum_czk += parseFloat(item.sum_czk) || 0;
        groupMap[key].sum_eur += parseFloat(item.sum_eur) || 0;
        groupMap[key].sum_pln += parseFloat(item.sum_pln) || 0;
        groupMap[key].orders_count += Number(item.orders_count) || 0;
      });

      // Step 3: Convert map to flat array for table
      this.yearlyStats = Object.values(groupMap);
    },

    processHalfYearlyStats() {
      const monthly = this.rawMonthly.filter(
          item => item.month !== null && item.day === null
      );

      const groupMap = {};

      monthly.forEach(item => {
        // e.g., "2024-12" => year: 2024, monthNum: 12
        const [yearStr, monthStr] = item.month.split("-");
        const year = parseInt(yearStr, 10);
        const monthNum = parseInt(monthStr, 10);
        const half = monthNum <= 6 ? 1 : 2; // 1 = H1, 2 = H2
        const key = `${item.eshop_id}_${year}_H${half}_${item.paid}`;
        const row_label = `${half} ${year}`;

        if (!groupMap[key]) {
          groupMap[key] = {
            eshop_id: item.eshop_id,
            eshop_name: this.getAliasById(item.eshop_id),
            year,
            half,
            row_label,
            paid: item.paid,
            sum_czk: 0,
            sum_eur: 0,
            sum_pln: 0,
            orders_count: 0
          };
        }

        groupMap[key].sum_czk += parseFloat(item.sum_czk) || 0;
        groupMap[key].sum_eur += parseFloat(item.sum_eur) || 0;
        groupMap[key].sum_pln += parseFloat(item.sum_pln) || 0;
        groupMap[key].orders_count += Number(item.orders_count) || 0;
      });

      this.halfyearlyStats = Object.values(groupMap);
    },

    processQuarterlyStats() {
      const monthly = this.rawMonthly.filter(
          item => item.month !== null && item.day === null
      );

      const groupMap = {};

      monthly.forEach(item => {
        const [yearStr, monthStr] = item.month.split("-");
        const year = parseInt(yearStr, 10);
        const monthNum = parseInt(monthStr, 10);
        const quarter = Math.floor((monthNum - 1) / 3) + 1;
        const key = `${item.eshop_id}_${year}_Q${quarter}_${item.paid}`;
        const row_label = `${quarter}Q ${String(year).slice(-2)}`;

        if (!groupMap[key]) {
          groupMap[key] = {
            eshop_id: item.eshop_id,
            eshop_name: this.getAliasById(item.eshop_id),
            year,
            quarter,
            row_label,
            paid: item.paid,
            sum_czk: 0,
            sum_eur: 0,
            sum_pln: 0,
            orders_count: 0
          };
        }

        groupMap[key].sum_czk += parseFloat(item.sum_czk) || 0;
        groupMap[key].sum_eur += parseFloat(item.sum_eur) || 0;
        groupMap[key].sum_pln += parseFloat(item.sum_pln) || 0;
        groupMap[key].orders_count += Number(item.orders_count) || 0;
      });

      this.quarterlyStats = Object.values(groupMap);
    },

    processMonthlyStats(rawStats) {
      return rawStats
          .filter(item => item.month)
          .map(item => {
            const [year, month] = item.month.split('-').map(Number);
            const d = new Date(year, month - 1, 1);
            const czechMonth = d.toLocaleString("cs-CZ", { month: "short" }).toUpperCase();
            return {
              eshop_id: item.eshop_id,
              year,
              month,
              row_label: `${czechMonth} ${year}`,
              paid: item.paid,
              sum_czk: Number(item.sum_czk || 0),
              sum_eur: Number(item.sum_eur || 0),
              sum_pln: Number(item.sum_pln || 0),
              orders_count: Number(item.orders_count || 0),
            }
          });
    },

    getISOWeekAndYear(dateStr) {
      const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
      const target = new Date(date.valueOf());
      const dayNr = (target.getDay() + 6) % 7; // Monday=0
      target.setDate(target.getDate() - dayNr + 3);  // Thursday of this week

      const firstThursday = new Date(target.getFullYear(), 0, 4);
      const firstThursdayDayNr = (firstThursday.getDay() + 6) % 7;
      firstThursday.setDate(firstThursday.getDate() - firstThursdayDayNr + 3);

      const weekYear = firstThursday.getFullYear();

      const weekNo = 1 + Math.round(
          (target - firstThursday) / (7 * 24 * 60 * 60 * 1000)
      );

      return {
        week: String(weekNo).padStart(2, '0'),
        year: weekYear
      };
    },

    processWeeklyStats(sourceArray) {
      const groupMap = {};

      // First pass: aggregate existing data
      sourceArray.forEach(item => {
        if (!item.day) return;
        const { week, year } = this.getISOWeekAndYear(item.day);
        const weekNo = `${week} ${year}`;
        const key = `${item.eshop_id}_${weekNo}_${item.paid}`;
        if (!groupMap[key]) {
          groupMap[key] = {
            eshop_id: item.eshop_id,
            eshop_name: this.getAliasById(item.eshop_id),
            row_label: weekNo,
            paid: item.paid,
            sum_czk: 0,
            sum_eur: 0,
            sum_pln: 0,
            orders_count: 0
          };
        }
        groupMap[key].sum_czk += parseFloat(item.sum_czk) || 0;
        groupMap[key].sum_eur += parseFloat(item.sum_eur) || 0;
        groupMap[key].sum_pln += parseFloat(item.sum_pln) || 0;
        groupMap[key].orders_count += Number(item.orders_count) || 0;
      });

      // Determine the range of dates covered
      const allEshopIds = [...new Set(Object.values(this.eshopMap).flat())];
      const paidStatuses = ['completed', 'all_statuses'];
      const minDate = new Date(sourceArray.length ? Math.min(...sourceArray.map(item => new Date(item.day))) : new Date());
      const maxDate = new Date(); // Today
      const msInDay = 24 * 60 * 60 * 1000;

      // Loop through all weeks between minDate and maxDate
      const weekSet = new Set(Object.keys(groupMap).map(k => k.split('_')[1]));
      let d = new Date(minDate);
      d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); // start from Monday of the first week
      while (d <= maxDate) {
        const { week, year } = this.getISOWeekAndYear(d);
        const weekNo = `${week} ${year}`;
        if (!weekSet.has(weekNo)) {
          for (const eshopId of allEshopIds) {
            for (const paid of paidStatuses) {
              const key = `${eshopId}_${weekNo}_${paid}`;
              if (!groupMap[key]) {
                groupMap[key] = {
                  eshop_id: eshopId,
                  eshop_name: this.getAliasById(eshopId),
                  row_label: weekNo,
                  paid: paid,
                  sum_czk: 0,
                  sum_eur: 0,
                  sum_pln: 0,
                  orders_count: 0
                };
              }
            }
          }
        }
        d.setDate(d.getDate() + 7);
      }

      return Object.values(groupMap).sort((a, b) => {
        const [weekA, yearA] = a.row_label.split(' ').map(Number);
        const [weekB, yearB] = b.row_label.split(' ').map(Number);
        return yearB - yearA || weekB - weekA;
      });
    },

    processDailyStats(sourceArray) {
      const mapByDateEshopPaid = {};

      // Index existing data by day + eshop + paid status
      sourceArray
          .filter(item => item.day)
          .forEach(item => {
            const key = `${item.day}_${item.eshop_id}_${item.paid}`;
            mapByDateEshopPaid[key] = item;
          });

      // Define eshops and paid statuses
      const allEshopIds = [...new Set(Object.values(this.eshopMap).flat())];
      const paidStatuses = ['completed', 'all_statuses']; // Or adjust based on your backend

      const minDate = new Date(sourceArray.length
          ? Math.min(...sourceArray.map(item => new Date(item.day)))
          : new Date()
      );
      const maxDate = new Date(); // Today

      const result = [];
      const msInDay = 24 * 60 * 60 * 1000;
      for (let d = new Date(minDate); d <= maxDate; d.setDate(d.getDate() + 1)) {
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yy = String(d.getFullYear()).slice(-2);
        const dayStr = d.toISOString().split('T')[0];
        const rowLabel = `${dd}/${mm}/${yy}`;

        for (const eshopId of allEshopIds) {
          for (const paid of paidStatuses) {
            const key = `${dayStr}_${eshopId}_${paid}`;
            if (mapByDateEshopPaid[key]) {
              // Use existing data
              result.push({
                ...mapByDateEshopPaid[key],
                row_label: rowLabel
              });
            } else {
              // Fill missing with zeros
              result.push({
                row_label: rowLabel,
                day: dayStr,
                eshop_id: eshopId,
                paid,
                sum_czk: 0,
                sum_eur: 0,
                sum_pln: 0,
                orders_count: 0
              });
            }
          }
        }
      }

      return result;
    },

    formatNumber(value) {
      if (value === undefined || value === null) return '–';
      if (value === 0) return '0';

      // Force integer rounding (removes .0 decimals)
      return Math.round(value).toLocaleString('cs-CZ', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },

    formatDelta(current, previous) {
      if (previous == null || previous === 0) {
        // Show a dash instead of NaN%
        return '–';
      }
      if (current == null) {
        return '–';
      }
      const delta = ((current - previous) / previous) * 100;
      if (isNaN(delta) || !isFinite(delta)) {
        return '–'; // Handle divide by zero or invalid results
      }
      return `${delta > 0 ? '+' : ''}${Math.round(delta)}%`;
    },

    getDeltaClass(current, previous) {
      if (previous == null || previous === 0 || current == null) {
        return '';  // Return no class if not enough data
      }
      const delta = ((current - previous) / previous) * 100;
      if (isNaN(delta) || !isFinite(delta)) {
        return '';  // No class
      }
      return delta >= 0 ? 'delta-positive' : 'delta-negative';
    },

    sortedYearOnYear() {
      const period = this.filters.periodSelect;
      let stats = [];
      let getPeriodKey = () => '';

      switch (period) {
        case 'half':
          stats = this.halfyearlyStats;
          getPeriodKey = s => `${s.half} ${s.year}`;
          break;
        case 'quarter':
          stats = this.quarterlyStats;
          getPeriodKey = s => `${s.quarter}Q ${s.year}`;
          break;
        case 'month':
          stats = this.monthlyStats;
          getPeriodKey = s => s.row_label;
          break;
        default:
          return [];
      }

      const now = new Date();
      const currentYear = now.getFullYear();
      const currentHalf = now.getMonth() < 6 ? 1 : 2;
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
      const currentMonth = now.getMonth() + 1;

      // Group by period key
      const grouped = {};

      stats.forEach(s => {
        // Filter out periods in the future
        if (
            (period === 'half' && (s.year > currentYear || (s.year === currentYear && s.half > currentHalf))) ||
            (period === 'quarter' && (s.year > currentYear || (s.year === currentYear && s.quarter > currentQuarter))) ||
            (period === 'month' && (s.year > currentYear || (s.year === currentYear && s.month > currentMonth)))
        ) return;

        // Filter for selected eshops and correct paid status
        if (!this.filters.eshopSelect.includes(Object.keys(this.eshopMap).find(key => {
          const ids = this.eshopMap[key];
          return Array.isArray(ids) ? ids.includes(s.eshop_id) : ids === s.eshop_id;
        }))) return;

        if (s.paid !== (this.filters.orderSelect === "all" ? "all_statuses" : "completed")) return;

        const key = getPeriodKey(s);
        if (!grouped[key]) {
          grouped[key] = { row_label: key, total: 0 };
          this.filters.eshopSelect.forEach(e => grouped[key][e] = 0);
        }

        // Find matching eshop key
        const eshopKey = Object.keys(this.eshopMap).find(key => {
          const ids = this.eshopMap[key];
          return Array.isArray(ids) ? ids.includes(s.eshop_id) : ids === s.eshop_id;
        });

        if (!eshopKey) return;

        let value;
        if (this.filters.contentSelect === "sales") {
          if (this.filters.currencySelect === "celkem") {
            // Use your defined rates for CZK, EUR, PLN
            value = (Number(s.sum_czk) || 0)
                + (Number(s.sum_eur) || 0) * this.rateEUR
                + (Number(s.sum_pln) || 0) * this.ratePLN;
          } else if (this.filters.currencySelect === "czk") {
            value = Number(s.sum_czk) || 0;
          } else if (this.filters.currencySelect === "eur") {
            value = Number(s.sum_eur) || 0;
          } else if (this.filters.currencySelect === "pln") {
            value = Number(s.sum_pln) || 0;
          } else {
            value = 0;
          }
        } else {
          value = Number(s.orders_count) || 0;
        }

        // const value = this.filters.contentSelect === "sales"
        //     ? (
        //         this.filters.currencySelect === "czk" ? Number(s.sum_czk)
        //             : this.filters.currencySelect === "eur" ? Number(s.sum_eur)
        //                 : this.filters.currencySelect === "pln" ? Number(s.sum_pln)
        //                     : 0
        //     )
        //     : Number(s.orders_count);

        grouped[key][eshopKey] += value;
        grouped[key].total += value;
      });

      // Convert grouped object to array and sort
      const result = Object.values(grouped);
      result.sort((a, b) => {
        const [a1, a2] = a.row_label.split(' ');
        const [b1, b2] = b.row_label.split(' ');
        if (period === 'half') return b1 - a1 || b2 - a2;
        if (period === 'quarter') return b1.replace('Q', '') - a1.replace('Q', '') || b2 - a2;
        if (period === 'month') {
          const [am, ay] = a.row_label.split(' ');
          const [bm, by] = b.row_label.split(' ');
          const monthOrder = ['LED', 'ÚNO', 'BŘE', 'DUB', 'KVĚ', 'ČVN', 'ČVC', 'SRP', 'ZÁŘ', 'ŘÍJ', 'LIS', 'PRO'];
          return monthOrder.indexOf(bm) - monthOrder.indexOf(am) || by - ay;
        }
        return 0;
      });

      return result;
    },

    getGroupKey(row) {
      switch (this.filters.periodSelect) {
        case 'quarter':
          // Extract the quarter number from "4Q 2024"
          return row.row_label.split(' ')[0];  // "4Q"
        case 'half':
          return row.row_label.split(' ')[0];  // "1" or "2"
        case 'month':
          return row.row_label.split(' ')[0];  // e.g., "LED"
        default:
          return null;
      }
    },

    async exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Data');

      // Header row
      const headers = ['Období'];
      if (this.filters.eshopSelect.length > 1) headers.push('Celkem');
      headers.push(...this.filters.eshopSelect.map(e => this.aliasMap[e] || e));

      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF37A8D6' } };
        cell.alignment = { horizontal: 'center' };
      });

      worksheet.addRow([]);

      // Total row
      const totals = this.globalMatrixTotals;
      const totalRow = ['Celkem'];
      if (this.filters.eshopSelect.length > 1) totalRow.push(totals.total);
      this.filters.eshopSelect.forEach(e => totalRow.push(totals[e]));
      const tRow = worksheet.addRow(totalRow);
      tRow.eachCell((cell, colNumber) => {
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4FFE6' } };
        if (colNumber === 1) {
          cell.alignment = { horizontal: 'center' };
        } else if (typeof cell.value === 'number') {
          cell.numFmt = '### ### ##0';
        }
      });

      worksheet.addRow([]);

      const data = (this.filters.deltaSelect === 'yea' && ['month','quarter','half'].includes(this.filters.periodSelect))
          ? this.sortedYearOnYear()
          : this.globalMatrix;

      for (let i = 0; i < data.length; i++) {
        const row = data[i];
        const rowArr = [row.row_label];
        if (this.filters.eshopSelect.length > 1) rowArr.push(row.total);
        this.filters.eshopSelect.forEach(e => rowArr.push(row[e] !== undefined ? row[e] : 0));

        const excelRow = worksheet.addRow(rowArr);

        excelRow.getCell(1).alignment = { horizontal: 'center' };
        excelRow.getCell(1).font = { bold: true };

        excelRow.eachCell((cell, colNumber) => {
          if (colNumber !== 1) {
            cell.numFmt = '0';
          }
        });

        if (row.row_label === this.currentPeriodKey) {
          // Highlight current period row
          excelRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6F4FF' } };
            cell.font = { bold: true };
            if (typeof cell.value === 'number') {
              cell.numFmt = '### ### ##0';
            }
          });
        } else {
          if (this.filters.eshopSelect.length > 1) {
            const celkemCell = excelRow.getCell(2);
            celkemCell.font = { bold: true };
            celkemCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4FFE6' } };
          }
          excelRow.eachCell((cell, colNumber) => {
            if (colNumber > 1 && typeof cell.value === 'number') {
              cell.numFmt = '### ### ##0';  // Space separator, no decimal
            }
          });
        }

        if (i < data.length - 1) {
          const next = data[i + 1];
          const deltaRow = ['Δ%'];
          if (this.filters.eshopSelect.length > 1) deltaRow.push(this.formatDelta(row.total, next.total));
          this.filters.eshopSelect.forEach(e => deltaRow.push(this.formatDelta(row[e], next[e])));
          const dRow = worksheet.addRow(deltaRow);

          dRow.eachCell((cell, colNumber) => {
            if (colNumber === 1) {
              cell.alignment = { horizontal: 'center' };
            } else {
              cell.alignment = { horizontal: 'right' };
            }

            if (colNumber > 1) {
              const val = parseFloat(cell.value);
              if (!isNaN(val)) {
                cell.font = { italic: true, color: { argb: val < 0 ? 'FFFF0000' : 'FF008000' } };
              } else {
                cell.font = { italic: true };
              }
            } else {
              cell.font = { italic: true };
            }
          });

          if (this.filters.eshopSelect.length > 1) {
            const celkemDeltaCell = dRow.getCell(2);
            celkemDeltaCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4FFE6' } };
          }
        }
      }

      // Auto width
      let globalMaxLength = 0;
      worksheet.columns.forEach(column => {
        column.eachCell({ includeEmpty: true }, cell => {
          const cellValue = cell.value ? cell.value.toString() : '';
          globalMaxLength = Math.max(globalMaxLength, cellValue.length);
        });
      });
      worksheet.columns.forEach(column => {
        column.width = globalMaxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${this.tableTitle.replace(/[\\/:*?"<>|]/g, '')}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async fetchMoreDefaultData() {
      const oldStart = this.dateRangeDefault[0];
      const newEnd = new Date(oldStart);
      newEnd.setDate(newEnd.getDate() - 1);
      const newStart = new Date(newEnd);
      newStart.setDate(newEnd.getDate() - 31);

      const payload = {
        period_type: this.filters.periodSelect,
        from_date: this.formatLocalDate(newStart),
        to_date: this.formatLocalDate(newEnd)
      };

      try {
        const response = await axios.post("/reporting/global_reporting_filter", payload);
        const newRawData = response.data.marketings_select || [];

        if (this.filters.periodSelect === 'day') {
          const newDaily = this.processDailyStats(newRawData);  // Format & fill
          this.extraDailyData = [...newDaily].sort((a, b) => {
            const parseDMY = s => {
              const [d, m, y] = s.row_label.split('/').map(Number);
              const yyyy = y < 50 ? 2000 + y : 1900 + y;
              return new Date(yyyy, m - 1, d);
            };
            return parseDMY(b.row_label) - parseDMY(a.row_label);
          });
        } else if (this.filters.periodSelect === 'week') {
          const newDaily = this.processDailyStats(newRawData);  // Convert raw to daily
          const newWeekly = this.processWeeklyStats(newDaily);  // Aggregate into weekly
          this.extraWeeklyData = [...newWeekly].sort((a, b) => {
            const [wa, ya] = a.row_label.split(' ').map(Number);
            const [wb, yb] = b.row_label.split(' ').map(Number);
            return yb - ya || wb - wa;
          });
        }

        this.hasFetchedMoreDefault = true;
      } catch (error) {
        console.error("Error fetching additional data:", error);
      }
    },

    getGroupIndexMap(sortedData) {
      const groupMap = {};
      let currentGroup = null;
      let groupIndex = -1;

      sortedData.forEach((row, i) => {
        const groupKey = this.getGroupKey(row);
        if (groupKey !== currentGroup) {
          groupIndex++;
          currentGroup = groupKey;
        }
        groupMap[row.row_label] = groupIndex;
      });

      return groupMap;
    },

    formatWeekLabel(label) {
      // Converts "23 2024" => "23/24", but returns unchanged for other periods
      if (!label || typeof label !== 'string') return label;
      // Match e.g. "23 2024"
      const match = label.match(/^(\d{1,2})\s+(\d{4})$/);
      if (match) {
        const week = match[1].padStart(2, '0');
        const yearShort = match[2].slice(-2);
        return `${week}/${yearShort}`;
      }
      return label; // Other periods (month, day, quarter, etc.) unchanged
    },

    formatMonthLabel(label) {
      // Expects: "LED 2024", "BŘE 2023", etc. or anything else
      if (!label) return label;
      // Try to match "MON YYYY"
      const match = label.match(/^([^\s]+)\s+(\d{4})$/);
      if (match) {
        const month = match[1];
        const year = match[2].slice(-2); // last 2 digits
        return `${month}${year}`;
      }
      return label;
    },

    formatQuarterLabel(label) {
      // "4Q 2024" => "4Q 24"
      if (!label) return label;
      const match = label.match(/^(\d)Q (\d{4})$/);
      if (match) {
        const q = match[1];
        const y = match[2].slice(-2);
        return `${q}Q ${y}`;
      }
      return label;
    }


  },

  // MOUNTED SECTION******************************************************

  mounted() {
    this.fetchOnLoad()
  }

}


</script>

<template>


  <div class="col-md-auto box">

    <div class="row" style="padding-top: 50px;">
      <h1 class="col flex-grow-1 heading">Reporting</h1>
    </div>

    <hr>

    <div id="controls" class="d-flex-column">

      <div id="first row" class="d-flex filter-row">

      <div id="orders" class="d-flex">
        <div class="group">
          <p>Objednávky</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-all" value="all" v-model="filters.orderSelect">
          <label for="rad-all">Všechny</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-paid"  value="paid" v-model="filters.orderSelect">
          <label for="rad-paid">Zaplacené</label>
        </div>
      </div>

      <div id="content" class="d-flex">

        <div class="group" style="margin-left: 46px; width: 78px;">
          <p>Data</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="radio-sales" value="sales" v-model="filters.contentSelect">
          <label for="radio-sales">Tržby</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="radio-count" value="count" v-model="filters.contentSelect">
          <label for="radio-count">Kusy</label>
        </div>

      </div>

      </div>

      <div id="currency" class="d-flex filter-row">
        <div class="group">
          <p>Měna</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-czk" value="czk" v-model="filters.currencySelect">
          <label for="rad-czk">CZK</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-eur" value="eur" v-model="filters.currencySelect">
          <label for="rad-eur">EUR</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-pln" value="pln" v-model="filters.currencySelect">
          <label for="rad-pln">PLN</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-all" value="celkem" v-model="filters.currencySelect">
          <label for="rad-all">Σ CZK</label>
        </div>
      </div>

      <div id="e-shops" class="d-flex-column">

        <div id="e-shops1" class="d-flex">
          <div class="group">
            <p>E-shopy</p>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-all" v-model="isAllChecked">
            <label for="check-all">Všechny</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-cs" value="easylingo_com_cs" v-model="filters.eshopSelect">
            <label for="check-el-cs">EL CZ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-sk" value="easylingo_com_sk" v-model="filters.eshopSelect">
            <label for="check-el-sk">EL SK</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-pl" value="easylingo_com_pl" v-model="filters.eshopSelect">
            <label for="check-el-pl">EL PL</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-es" value="easylingo_com_es" v-model="filters.eshopSelect">
            <label for="check-el-es">EL ES</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-en" value="easylingo_com_en" v-model="filters.eshopSelect">
            <label for="check-el-en">EL EN</label>
          </div>

        </div>

        <div id="e-shops2" class="d-flex">
          <div class="group">
            <p> </p>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-oj-old" value="onlinejazyky_old" v-model="filters.eshopSelect">
            <label for="check-oj-old">OJ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-oj-info" value="onlinejazyky_info" v-model="filters.eshopSelect">
            <label for="check-oj-info">OJ info</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-oj-cz-eshop" value="onlinejazyky_eshop" v-model="filters.eshopSelect">
            <label for="check-oj-cz-eshop">OJ eshop</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-miluju" value="milujujazyky_cz" v-model="filters.eshopSelect">
            <label for="check-miluju">MilJaz</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-darky" value="jazykovedarky_cz" v-model="filters.eshopSelect">
            <label for="check-darky">JazDar</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-umeni" value="umenijazyku_cz" v-model="filters.eshopSelect">
            <label for="check-umeni">UmeJaz</label>
          </div>

        </div>

        <div id="e-shops3" class="d-flex filter-row">
          <div class="group">
            <p> </p>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-kk-cz" value="konverzacniklub_cz" v-model="filters.eshopSelect">
            <label for="check-kk-cz">KKlub</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-fapi" value="fapi_sk" v-model="filters.eshopSelect">
            <label for="check-fapi">Fapi SK</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-stud-oj" value="studovna_oj" v-model="filters.eshopSelect">
            <label for="check-stud-oj">Stud OJ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-stud-el" value="studovna_el" v-model="filters.eshopSelect">
            <label for="check-stud-oj">Stud EL</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-onlajnovka" value="onlajnovka" v-model="filters.eshopSelect">
            <label for="check-onlajnovka">Onla</label>
          </div>

        </div>

      </div>

      <div id="delta" class="d-flex" v-if="['month', 'quarter', 'half'].includes(filters.periodSelect)">
        <div class="group">
          <p>Trend</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-chrono" value="chr" v-model="filters.deltaSelect">
          <label for="rad-chrono">Postupně</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-yearly" value="yea" v-model="filters.deltaSelect">
          <label for="rad-yearly">Meziročně</label>
        </div>
      </div>

      <div id="period" class="d-flex filter-row">
        <div class="group">
          <p>Období</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-year" value="year" v-model="filters.periodSelect">
          <label for="rad-year">Roční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-half" value="half" v-model="filters.periodSelect">
          <label for="rad-half">Půlroční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-quarter" value="quarter" v-model="filters.periodSelect">
          <label for="rad-quarter">Čtvrtletní</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-month" value="month" v-model="filters.periodSelect">
          <label for="rad-month">Měsíční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-week" value="week" v-model="filters.periodSelect">
          <label for="rad-week">Týdenní</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-day" value="day" v-model="filters.periodSelect">
          <label for="rad-day">Denní</label>
        </div>
      </div>

      <div id="buttons" class="buttons-wrapper">
        <div class="group">
          <p> </p>
        </div>

        <div class="datepicker-wrapper">
          <div v-if="['day', 'week'].includes(filters.periodSelect) && isEshopSelected">
            <label>Vyberte vlastní období (max 3 měsíce):</label>
            <Datepicker
                v-model="dateRangeCustom"
                :range="true"
                :min-date="minSelectableDate"
                :max-date="maxSelectableDate"
                format="dd/MM/yyyy"
                :enable-time-picker="false"
                placeholder="Otevřít kalendář"
            />
          </div>

          <div class="button-group">
            <button
                id="show"
                v-if="['day', 'week'].includes(filters.periodSelect) && isEshopSelected"
                @click="validateAndSubmit"
                :disabled="isButtonDisabled"
            >
              Zobrazit
            </button>

            <button
                id="export"
                class="export-button"
                @click="exportToExcel"
                v-if="isPeriodDataAvailable && isEshopSelected"
            >
              Exportovat do Excelu
            </button>

          </div>

        </div>

      </div>

      <hr>

<!--      <div v-if="filters.periodSelect === 'year'">{{yearlyStats}}</div>-->

<!--      <div v-if="filters.periodSelect === 'week'">RAW: {{rawDailyDefault}}</div>-->
<!--      <div v-if="filters.periodSelect === 'day'">RAW: {{rawDailyDefault}}</div>-->

<!--      <hr>-->

<!--      <div v-if="filters.periodSelect === 'week'">DEFAULT: {{weeklyStatsDefault}}</div>-->
<!--      <div v-if="filters.periodSelect === 'day'">DEFAULT: {{dailyStatsDefault}}</div>-->


    <div v-if="isEshopSelected">

      <!-- Chronological Table ("chr") -->
      <div
          v-if="isPeriodDataAvailable && filters.deltaSelect === 'chr'"
          class="card card-body"
          style="display: inline-block; min-width: auto;"
      >
        <h4 class="font-weight-bold">{{ tableTitle }}</h4>

        <table
            class="table table-bordered text-right"
            :class="{ 'equal-cols': filters.eshopSelect.length === 1 }"
        >

          <thead>
          <tr>
            <th class="text-center" style="white-space: nowrap; font-weight: bold;">Období</th>
            <th v-if="filters.eshopSelect.length > 1"
                class="text-right total-column"
                :style="globalColumnStyle">Celkem</th>
            <th v-for="eshop in filters.eshopSelect" :key="'head-' + eshop"
                :style="globalColumnStyle">
              {{ aliasMap[eshop] }}
            </th>
          </tr>
          </thead>

          <tbody>

          <tr class="spacer-row">
            <td colspan="100%"></td>
          </tr>

<!--          <tr class="total-row">-->
<!--            <td class="text-center" style="font-weight: bold;">Celkem</td>-->
<!--            <td v-if="filters.eshopSelect.length > 1" :style="globalColumnStyle" class="total-column">-->
<!--              <span style="font-weight: bold;">{{ formatNumber(globalMatrixTotals.total) }}</span>-->
<!--            </td>-->
<!--            <td v-for="eshop in filters.eshopSelect" :key="'total-' + eshop" :style="globalColumnStyle" class="number-row">-->
<!--              {{ formatNumber(globalMatrixTotals[eshop]) }}-->
<!--            </td>-->
<!--          </tr>-->

<!--          &lt;!&ndash; Spacer below Celkem &ndash;&gt;-->
<!--          <tr class="spacer-row">-->
<!--            <td colspan="100%"></td>-->
<!--          </tr>-->
          <template v-for="(row, index) in globalMatrix" :key="row.row_label">

            <!-- week/day table -->
            <template v-if="['week', 'day'].includes(filters.periodSelect)">
              <tr :class="{ 'highlight-period': row.row_label === currentPeriodKey,
                  'number-row': index % 2 === 1 && row.row_label !== currentPeriodKey }">
                <td style="font-weight: bold; text-align: center;">
                  {{
                    filters.periodSelect === 'week'
                        ? formatWeekLabel(row.row_label)
                        : filters.periodSelect === 'month'
                            ? formatMonthLabel(row.row_label)
                            : row.row_label
                  }}
                </td>

                <td v-if="filters.eshopSelect.length > 1" :style="globalColumnStyle" class="total-column">
                  <span style="font-weight: bold;">{{ formatNumber(row.total) }}</span>
                </td>
                <td v-for="eshop in filters.eshopSelect" :key="eshop" :style="globalColumnStyle">
                  {{ formatNumber(row[eshop]) }}
                </td>
              </tr>
              <tr v-if="index < globalMatrix.length - 1"
                  :class="{ 'highlight-period': row.row_label === currentPeriodKey,
                  'number-row': index % 2 === 1 && row.row_label !== currentPeriodKey }"
              >
                <td style="text-align: center;">Δ%</td>
                <td v-if="filters.eshopSelect.length > 1" :style="globalColumnStyle" class="total-column">
                <span :class="getDeltaClass(globalMatrix[index].total, globalMatrix[index + 1].total)">
                  {{ formatDelta(globalMatrix[index].total, globalMatrix[index + 1].total) }}
                </span>
                </td>
                <td v-for="eshop in filters.eshopSelect" :key="'delta-' + eshop" :style="globalColumnStyle">
                <span :class="getDeltaClass(globalMatrix[index][eshop], globalMatrix[index + 1][eshop])">
                  {{ formatDelta(globalMatrix[index][eshop], globalMatrix[index + 1][eshop]) }}
                </span>
                </td>
              </tr>
            </template>

            <!-- month or longer table -->
            <template v-else>
              <tr :class="{ 'highlight-period': row.row_label === currentPeriodKey }">
                <td class="number-row" style="font-weight: bold; text-align: center;">{{ row.row_label }}</td>
                <td v-if="filters.eshopSelect.length > 1" :style="globalColumnStyle" class="total-column">
                  <span style="font-weight: bold;">{{ formatNumber(row.total) }}</span>
                </td>
                <td v-for="eshop in filters.eshopSelect" :key="eshop" :style="globalColumnStyle" class="number-row">
                  {{ formatNumber(row[eshop]) }}
                </td>
              </tr>
              <tr v-if="index < globalMatrix.length - 1">
                <td style="text-align: center;">Δ%</td>
                <td v-if="filters.eshopSelect.length > 1" :style="globalColumnStyle" class="total-column">
                <span :class="getDeltaClass(globalMatrix[index].total, globalMatrix[index + 1].total)">
                  {{ formatDelta(globalMatrix[index].total, globalMatrix[index + 1].total) }}
                </span>
                </td>
                <td v-for="eshop in filters.eshopSelect" :key="'delta-' + eshop" :style="globalColumnStyle">
                <span :class="getDeltaClass(globalMatrix[index][eshop], globalMatrix[index + 1][eshop])">
                  {{ formatDelta(globalMatrix[index][eshop], globalMatrix[index + 1][eshop]) }}
                </span>
                </td>
              </tr>
            </template>
          </template>
          </tbody>

        </table>

      </div>

      <!-- Year-on-Year Table ("yea") - only for month, quarter, half -->
      <div
          v-if="isPeriodDataAvailable && filters.deltaSelect === 'yea' && ['month', 'quarter', 'half'].includes(filters.periodSelect)"
          class="card card-body"
          style="display: inline-block; min-width: auto;"
      >
        <h4 class="font-weight-bold">{{ tableTitle }}</h4>
        <table class="table table-bordered text-right" style="width: auto; table-layout: fixed;">

          <thead>
          <tr>
            <th class="text-center" style="white-space: nowrap;">Období</th>
            <th v-if="filters.eshopSelect.length > 1" :style="yearOnYearColumnStyle" class="text-right total-column">Celkem</th>
            <th v-for="eshop in filters.eshopSelect" :key="'head-yea-' + eshop" :style="yearOnYearColumnStyle">
              {{ aliasMap[eshop] }}
            </th>
          </tr>
          </thead>

          <tbody>

          <tr class="spacer-row">
            <td colspan="100%"></td>
          </tr>

<!--          <tr class="total-row">-->
<!--            <td class="text-center" style="font-weight: bold;">Celkem</td>-->
<!--            <td v-if="filters.eshopSelect.length > 1" :style="yearOnYearColumnStyle" class="total-column">-->
<!--              <span style="font-weight: bold;">{{ formatNumber(globalMatrixTotals.total) }}</span>-->
<!--            </td>-->
<!--            <td v-for="eshop in filters.eshopSelect" :key="'total-yea-' + eshop" :style="yearOnYearColumnStyle" class="number-row">-->
<!--              {{ formatNumber(globalMatrixTotals[eshop]) }}-->
<!--            </td>-->
<!--          </tr>-->

<!--          <tr class="spacer-row">-->
<!--            <td colspan="100%"></td>-->
<!--          </tr>-->

          <template v-for="(row, index) in sortedYearOnYear()" :key="row.row_label">

            <!-- Spacer Row -->
            <tr v-if="index > 0 && getGroupKey(row) !== getGroupKey(sortedYearOnYear()[index - 1])" class="spacer-row">
              <td :colspan="filters.eshopSelect.length + 2"></td>
            </tr>

            <!-- Data Row -->
<!--            <tr :class="{'highlight-period': row.row_label === currentPeriodKey}">-->

<!--              <td class="number-row" style="font-weight: bold;">{{ row.row_label }}</td>-->
<!--              <td v-if="filters.eshopSelect.length > 1" :style="yearOnYearColumnStyle" class="total-column" style="font-weight: bold;">{{ formatNumber(row.total) }}</td>-->
<!--              <td  class="number-row" v-for="eshop in filters.eshopSelect" :key="eshop" :style="yearOnYearColumnStyle">{{ formatNumber(row[eshop]) }}</td>-->
<!--            </tr>-->
            <tr :class="{
                'highlight-period': row.row_label === currentPeriodKey,
                'alt-group': groupIndexMap[row.row_label] % 2 === 1
              }">
              <td class="number-row" style="font-weight: bold;">
                {{
                  filters.periodSelect === 'month' ? formatMonthLabel(row.row_label)
                      : filters.periodSelect === 'quarter' ? formatQuarterLabel(row.row_label)
                          : row.row_label
                }}
              </td>
              <td
                  v-if="filters.eshopSelect.length > 1"
                  class="total-column number-row"
                  :style="yearOnYearColumnStyle"
                  style="font-weight: bold;"
              >
                {{ formatNumber(row.total) }}
              </td>
              <td
                  v-for="eshop in filters.eshopSelect"
                  :key="eshop"
                  class="number-row"
                  :style="yearOnYearColumnStyle"
              >
                {{ formatNumber(row[eshop]) }}
              </td>
            </tr>

            <!-- Delta Row -->
            <tr v-if="index < sortedYearOnYear().length - 1 && getGroupKey(row) === getGroupKey(sortedYearOnYear()[index + 1])">
              <td style="text-align: center;">Δ%</td>
              <td v-if="filters.eshopSelect.length > 1" :style="yearOnYearColumnStyle" class="total-column">
              <span :class="getDeltaClass(row.total, sortedYearOnYear()[index + 1].total)">
                {{ formatDelta(row.total, sortedYearOnYear()[index + 1].total) }}
              </span>
                    </td>
                    <td v-for="eshop in filters.eshopSelect" :key="'delta-' + eshop" :style="yearOnYearColumnStyle">
              <span :class="getDeltaClass(row[eshop], sortedYearOnYear()[index + 1][eshop])">
                {{ formatDelta(row[eshop], sortedYearOnYear()[index + 1][eshop]) }}
              </span>
              </td>
            </tr>

          </template>
          </tbody>

        </table>
      </div>
    </div>

      <div v-else class="text-left" style="margin-top: 20px; font-weight: bold; font-size: 18px;">
        Vyberte alespoň jeden e-shop.
      </div>

    </div>
  </div>


</template>

<style scoped>

.filter-row {
  margin-bottom: 30px;
}

.check-mate {
  margin-right: 25px;
  width: 100px;
}

.check-mate input {
  margin-right: 5px;
}

.check-mate-end input {
  margin-right: 5px;
}

.check-mate label {
  margin-top: 7px;
  font-size: 18px;
}

.check-mate-end label {
  margin-top: 7px;
  font-size: 18px;
}

.group {
  width: 130px;
}

.group p {
  margin: 0;
  margin-top: 7px;
  margin-right: 25px;
  font-size: 18px;
  font-weight: bolder;
}

#buttons {
  margin-top: 10px;
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
}

.datepicker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 400px;
}

.datepicker-wrapper label {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: bold;
}

.datepicker-wrapper .show-button {
  margin-top: 12px;
}

.datepicker-wrapper .show-button button {
  background-color: #37A8D6;
  color: white;
  border-radius: 5px;
  border: none;
  padding: 7px 20px;
  text-transform: uppercase;
  font-weight: bold;
}

button {
  background-color: #37A8D6;
  color: white;
  border-radius: 5px;
  border: none;
  padding: 7px 20px 7px 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.show-button {
  margin-right: 180px;
}

td.total-column,
th.total-column {
  background-color: #f4ffe6 !important;
}

.highlight-period {
  background-color: #CDE5FA !important; /* light blue */
  font-weight: bold;
}

.highlight-period td {
  background-color: #CDE5FA !important;
}

.number-row {
  background-color: #E6E3E2;
}

.alt-group td{
  background-color: #F9F9F6 !important;
}

.alt-group td.total-column {
  background-color: #f4ffe6 !important;
}

.highlight-period td.number-row {
  background-color: #CDE5FA !important;
}

tr.highlight-period > td.total-column {
  background-color: #CDE5FA !important;
  font-weight: bold;
}

.spacer-row td {
  padding: 7px 0;
  background-color: transparent !important;
  border: none !important;
}

.delta-positive {
  color: green;
}

.delta-negative {
  color: red;
}

.total-row {
  font-weight: bold;
  font-size: 1.1em;
  border-top: 2px solid #ccc;
  background-color: #f4ffe6;
}

.total-row .number-row {
  background-color: #f4ffe6 !important;
}

.total-row td {
  background-color: #f4ffe6 !important;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

#export.export-button {
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
  border: none;
  padding: 7px 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.table th, .table td {
  padding-left: 7px;
  padding-right: 6px;
}

.table.equal-cols th,
.table.equal-cols td {
  width: 50%;
  min-width: 120px; /* optional: tweak as needed */
  max-width: 400px; /* optional */
}

.highlight-period,
.highlight-period td,
tr.highlight-period > td {
  border: 1px solid #fff !important;
}

.number-row,
.number-row td {
  border: 1px solid #fff !important;
}

td.total-column,
th.total-column {
  border: 1px solid #cfcfcf !important;
}

.alt-group td {
  border: 1px solid #cfcfcf !important;
}

</style>